<template>
    <div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
      <HeadNav selectedLanguage="en" page="instasave"  
          :gotodownload="gotodownload"
          :apk="apk"/>
      <div id="page" class="site container hfeed">
        <div id="content" class="site-content">
          <div id="primary" class="content-area">
            <main id="maincontent" class="site-main">
              <!-- Hero Section -->
              <HeroSection 
                :title="heroTitle"
                :subtitle="heroSubtitle"
                :input-placeholder="inputPlaceholder"
                :active-tab="activeTab"
                @tab-change="switchTab"
                @download-content="downloadContent"
                @go-to-download="goToDownload"
                @join-telegram="joinTelegramChannel"
              />
              <div class="home-wrapper">
               
    
                <!-- How to Download Section -->
                <HowToSection
                  :title="'Cara download video & foto dari Instagram - InstaSave'"
                  :steps="howToSteps"
                />
    
                <!-- Why Use InstaSave Section -->
                <section class="why-use-section">
                  <h2 class="section-title">Kenapa pakai Instasave untuk download dari Instagram (IG)?</h2>
                  <ul class="benefits-list">
                    <li>
                      <h3>Download tanpa batas</h3>
                      <p>Tidak perlu instal aplikasi atau login. Download video dan foto sebanyak yang kamu mau setiap hari tanpa batasan.</p>
                    </li>
                    <li>
                      <h3>100% anonim</h3>
                      <p>Bisa dipakai di HP maupun komputer. Tetap anonim saat browsing dan download dari Instagram tanpa berbagi data pribadi.</p>
                    </li>
                    <li>
                      <h3>Cepat & sepenuhnya gratis</h3>
                      <p>Bisa untuk post, Reels, foto carousel, dan beberapa link Story publik. Layanan kami otomatis, cepat, aman, dan 100% gratis.</p>
                    </li>
                  </ul>
                </section>
    
                <!-- App Recommendation Section -->
                <AppRecommendationSection 
                  :title="appRecommendationTitle"
                  :description="appRecommendationDescription"
                  :button-text="appRecommendationButtonText"
                  :image-src="appRecommendationImageSrc"
                  :image-alt="appRecommendationImageAlt"
                  @go-to-download="goToDownload"
                />
    
                <!-- Why Choose Online First Section -->
                <section class="choice-section">
                  <div class="choice-card">
                    <h3>Mengapa pakai versi online dulu, baru aplikasi InstaSave?</h3>
                    <ul>
                      <li><strong>Online:</strong> paling cepat untuk simpan sesekali, tanpa instal apa pun, dan bisa di semua perangkat.</li>
                      <li><strong>Aplikasi:</strong> paling pas untuk pengguna aktif — download banyak sekaligus, bisa jalan di latar belakang, galeri offline, dan penamaan file lebih rapi.</li>
                      <li>Kalau kamu ingin berbagi pengalaman, belajar cara baru, atau memecahkan masalah seputar download konten Instagram, silakan gabung ke grup <a href="https://freegbdownload.com/" class="jump-url" target="_blank">GB WhatsApp</a> untuk diskusi.</li>
                    </ul>
              </div>
                </section>
    
                <!-- Features Sections -->
                <FeaturesGrid :features="features" />
    
                <!-- FAQ Section -->
                <section class="faq-section">
                  <h2 class="section-title">FAQ & Troubleshooting</h2>
                  <div class="faq-container">
                    <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
                      <div class="faq-question" @click="toggleFaq(index)">
                        <div style="font-size: 1.2rem; font-weight: 600;">{{ faq.question }}</div>
                        <span class="faq-toggle">{{ expandedFaqs.includes(index) ? '−' : '+' }}</span>
                      </div>
                      <div v-if="expandedFaqs.includes(index)" class="faq-answer">
                        <p v-html="faq.answer"></p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </main> 
          </div>
        </div>
      </div>
    
    </div>
    </template>
    
    <script>
    import '@/css/base.scss';
    import '@/css/index.scss';
    import HeadNav from '@/components/HeadNav.vue';
    import Footer from '@/components/Footer.vue';
    import HeroSection from '@/components/HeroSection.vue';
    import HowToSection from '@/components/HowToSection.vue';
    import FeaturesGrid from '@/components/FeaturesGrid.vue';
    import AppRecommendationSection from '@/components/AppRecommendationSection.vue';
    
    export default {
      name: 'Home',
      components: {
        HeadNav,
        Footer,
        HeroSection,
        HowToSection,
        FeaturesGrid,
        AppRecommendationSection
      },
      head() {
        return {
          title: 'InstaSave – Download video & foto Instagram',
          meta: [
            {
              hid: 'description',
              name: 'description',
              content: 'InstaSave membantu kamu download video dan foto Instagram secara online dengan mudah. Tempel link, klik download, lalu simpan konten IG favorit kamu dalam kualitas tinggi.'
            },
            {
              hid: 'keywords',
              name: 'keywords',
              content: 'download video Instagram, instasave, download foto Instagram'
            }
          ]
        }
      },
      data() {
        return {
          pageName: 'home',
          instagramLink: '',
          expandedFaqs: [],
          activeTab: '',
          heroTitle: 'InstaSave – Download Instagram',
          heroSubtitle: 'Cukup tempel link Instagram lalu klik tombol download',
          inputPlaceholder: 'Tempel link di sini',
          appRecommendationTitle: 'InstaSave: download Instagram di Android (rekomendasi aplikasi)',
          appRecommendationDescription: 'Kalau kamu sering menyimpan konten, aplikasi akan jauh lebih praktis. InstaSave dibuat khusus untuk Android dengan fokus ke kecepatan, download banyak sekaligus, dan galeri yang rapi.',
          appRecommendationButtonText: 'Download InstaSave gratis',
          appRecommendationImageSrc: require('@/assets/home/home-1.webp'),
          appRecommendationImageAlt: 'InstaSave App',
          faqs: [
            {
              question: "Apakah saya harus login untuk download?",
              answer: "Tidak, untuk sebagian besar post publik melalui alat online. Beberapa Story atau konten privat butuh akses yang sudah kamu punya di aplikasi Instagram; aplikasi Android kami bisa membantu saat kamu membagikan link yang bisa kamu lihat."
            },
            {
              question: "Hasil download tidak ada suaranya, kenapa?",
              answer: "Beberapa audio menggunakan lisensi sehingga alat pihak ketiga tidak bisa menyertakan suaranya. Coba download lewat aplikasi dengan opsi audio asli jika tersedia, atau simpan versi lain dari kreator (dengan izin)."
            },
            {
              question: "Kenapa video jadi buram setelah disimpan?",
              answer: "Instagram mengompres media. Pilih kualitas tertinggi yang tersedia saat download. Di Android, aktifkan opsi \"Prefer HD\" di pengaturan Instasave."
            },
            {
              question: "Bisakah saya download dari akun privat?",
              answer: "Hanya jika kamu mengikuti akun tersebut dan bisa melihat kontennya di aplikasi — lalu bagikan/salin link ke Instasave. Jangan pernah mencoba melewati pengaturan privasi."
            },
            {
              question: "File saya tersimpan di mana?",
              answer: "Desktop: di folder Downloads browser kamu.<br>Android: Penyimpanan internal › Pictures/Movies › Instasave (bisa diatur di pengaturan).<br>iPhone (alat online): aplikasi Files atau Photos (tergantung cara kamu menyimpan)."
            },
            {
              question: "Kenapa tertulis link \"invalid\"?",
              answer: "Pastikan kamu menyalin URL lengkapnya (tanpa spasi tambahan). Buka lagi Instagram, ketuk Bagikan › Salin link, lalu tempel lagi di sini."
            },
            {
              question: "Apakah akun saya bisa kena banned karena pakai aplikasi?",
              answer: "Kami tidak pernah meminta kata sandi Instagram kamu. Tetap ikuti aturan Instagram dan hanya download konten yang memang diizinkan."
            },
            {
              question: "Bisakah saya menjadwalkan atau download banyak sekaligus?",
              answer: "Bisa — di Android, kamu bisa tempel banyak link ke Instasave, atau aktifkan fitur tangkap otomatis dari clipboard untuk mengantrikan file."
            },
            {
              question: "Apakah ini bisa untuk Carousel dan Highlight?",
              answer: "Bisa. Pilih item satu per satu (online) atau gunakan opsi Download semua (di aplikasi) agar lebih praktis."
            },
            {
              question: "Apakah ini gratis?",
              answer: "Downloader online dan Instasaver untuk Android tersedia secara gratis."
            }
          ],
          howToSteps: [
            {
              title: "Langkah 1: Salin link Instagram",
              items: [
                "Buka Instagram (aplikasi atau web).",
                "Ketuk ikon tiga titik (atau Bagikan) pada post, Reel, Story highlight, atau IGTV.",
                "Pilih Salin link."
              ]
            },
            {
              title: "Langkah 2: Tempel link",
              items: [
                "Kembali ke halaman ini dan tempel link ke kotak download."
              ]
            },
            {
              title: "Langkah 3: Download video/foto",
              items: [
                "Tekan tombol Download.",
                "Pilih Video atau Foto (kalau carousel, pilih file satu per satu).",
                "Simpan ke perangkat kamu (HP: Files/Fotos, desktop: folder Downloads)."
              ]
            }
          ],
          features: [
            {
              title: "Download video Instagram",
              description: "Dengan alat online kami, kamu bisa download video Instagram hanya dengan satu klik. Salin link video, tempel di kotak, lalu simpan langsung ke perangkat kamu dalam format MP4. Tanpa instal software, dan bisa di desktop maupun mobile.",
              imageSrc: require('@/assets/home/home-2.webp'),
              imageAlt: "Download video Instagram"
            },
            {
              title: "Download foto Instagram",
              description: "Gunakan downloader kami untuk download foto Instagram dengan cepat dan resolusi tinggi. Baik satu foto maupun satu post carousel penuh, cukup tempel link dan simpan gambarnya seketika. Cepat, simpel, dan sepenuhnya online.",
              imageSrc: require('@/assets/home/home-3.webp'),
              imageAlt: "Download foto Instagram"
            },
            {
              title: "Penyimpan Story Instagram",
              description: "Fitur Story Saver kami membantu kamu menyimpan Story Instagram sebelum menghilang. Salin link Story, tempel di alat ini, lalu download langsung ke HP atau komputer kamu. Bisa untuk highlight dan Story publik tanpa login.",
              imageSrc: require('@/assets/home/home-4.webp'),
              imageAlt: "Penyimpan Story Instagram"
            },
            {
              title: "Download Reels Instagram",
              description: "Mau simpan Reels secara offline? Fitur download Reels Instagram kami memungkinkan kamu menyimpan Reels sebagai file MP4. Cukup tempel link Reels ke alat ini dan download dengan kualitas tinggi untuk ditonton kapan saja, di mana saja.",
              imageSrc: require('@/assets/home/home-5.webp'),
              imageAlt: "Download Reels Instagram"
            },
            {
              title: "Download post Instagram",
              description: "Dengan fitur download post Instagram, kamu bisa menyimpan post lengkap termasuk foto, video, atau album carousel. Tinggal salin link post dan tempel di sini untuk download semua media dari post tersebut.",
              imageSrc: require('@/assets/home/home-6.webp'),
              imageAlt: "Download post Instagram"
            },
            {
              title: "Download IGTV",
              description: "Fitur download IGTV kami memudahkan kamu menyimpan video panjang dari Instagram. Salin link IGTV, tempel di downloader, lalu dapatkan video dalam format MP4 untuk ditonton secara offline. Cocok untuk tutorial, acara, dan wawancara.",
              imageSrc: require('@/assets/home/home-7.webp'),
              imageAlt: "Download IGTV"
            }
          ]
        };
      },
      computed: {
        currentTabTitle() {
          const currentTab = this.navTabs.find(tab => tab.id === this.activeTab);
          return currentTab ? currentTab.title : 'Instagram Download';
        }
      },
      methods: {
        switchTab(tabId) {
          this.activeTab = tabId;
          console.log('Switching to tab:', tabId);
        },
        pasteFromClipboard() {
          if (navigator.clipboard && navigator.clipboard.readText) {
            navigator.clipboard.readText().then(text => {
              this.instagramLink = text;
            }).catch(err => {
              console.error('Failed to read clipboard contents: ', err);
            });
              } else {
            // Fallback for older browsers
            alert('Please paste the link manually');
          }
        },
        downloadContent() {
          // 直接下载APK文件，参考instagram-apk-download页面的实现
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Downloading APK:', apkUrl);
        },
        toggleFaq(index) {
          const expandedIndex = this.expandedFaqs.indexOf(index);
          if (expandedIndex > -1) {
            this.expandedFaqs.splice(expandedIndex, 1);
              } else {
            this.expandedFaqs.push(index);
              }
        },
        gotodownload() {
          // 直接下载APK文件
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Download APK:', apkUrl);
        },
        goToDownload() {
          // 跳转到下载页面
          this.$router.push('/instagram-apk-downlad/');
        },
        joinTelegramChannel() {
          // 跳转到Telegram频道
          window.open('https://t.me/+M75kow80SlQ1MjZl', '_blank');
        },
      },
    };
    </script>
    
    <style scoped>
    
    .home-wrapper {
      max-width: 1000px;
      margin: 0 auto;
      margin-top: 1rem;
    }
    
    /* Hero Section - 重新设计 */
    .hero-section {
      background: linear-gradient(80deg, #D009FF 0%, #3b82f6 100%);
      color: white;
      padding: 60px 20px 80px;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      overflow: hidden;
    }
    
    .hero-content {
      max-width: 1000px;
      margin: 0 auto;
    }
    
    /* Logo - 移除，因为图片中没有显示logo */
    .hero-logo {
      display: none;
    }
    
    /* Navigation Tabs */
    .nav-tabs {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-bottom: 50px;
      flex-wrap: wrap;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      padding: 8px;
      border-radius: 30px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 50px;
    }
    
    .nav-tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 16px;
      background: transparent;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      flex: 1;
      justify-content: center;
    }
    
    .nav-tab:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }
    
    .nav-tab.active {
      background: rgba(255, 255, 255, 0.25);
      color: white;
      font-weight: 600;
    }
    
    .tab-icon {
      font-size: 14px;
    }
    
    .tab-text {
      font-weight: inherit;
    }
    
    /* Main Title */
    .hero-title {
      font-size: 2.8rem;
      font-weight: 600;
      color: white;
      text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
      letter-spacing: -0.5px;
    }
    
    /* Input Section */
    .paste-link-container {
      max-width: 600px;
      margin: 0 auto;
    }
    
    .coming-soon-note {
      text-align: center;
      margin-top: 15px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      font-style: italic;
      opacity: 0.9;
    }
    
    .action-buttons {
      display: flex;
      gap: 15px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      flex-wrap: wrap;
    }
    
    .download-app-btn {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .download-app-btn:hover {
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
    
    .telegram-btn {
      background: transparent;
      color: white;
      border: 2px solid rgba(255, 255, 255, 0.3);
      padding: 0px 22px;
      height: min-content;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
    }
    
    .telegram-btn:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.6);
      transform: translateY(-2px);
    }
    
    .btn-icon {
      width: 34px;
      height: 34px;
      object-fit: contain;
    }
    
    .input-group {
      display: flex;
      gap: 0;
      background: white;
      padding: 4px;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
      align-items: center;
      border: 1px solid rgba(0,0,0,0.05);
    }
    
    .link-input {
      flex: 1;
      border: none;
      padding: 16px 20px;
      font-size: 15px;
      border-radius: 8px;
      outline: none;
      background: transparent;
      color: #333;
    }
    
    .link-input::placeholder {
      color: #9ca3af;
      font-weight: 400;
    }
    
    .paste-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 12px 16px;
      background: #e5e7eb;
      color: #6b7280;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 13px;
      font-weight: 500;
      margin-right: 4px;
    }
    
    .paste-btn:hover {
      background: #d1d5db;
      color: #374151;
    }
    
    .paste-icon {
      font-size: 14px;
    }
    
    .download-btn {
      background: #ef4444;
      color: white;
      border: none;
      padding: 16px 24px;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }
    
    .download-btn:hover {
      background: #dc2626;
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    }
    
    /* Section Styles - 简洁的标题设计 */
    .section-title {
      text-align: center;
      margin-bottom: 40px;
      color: #333;
    }
    
    
    /* Why Use Section - 浅灰背景 */
    .why-use-section {
      padding: 40px 20px;
      background: #f8f9fa;
    }
    
    .benefits-list {
      max-width: 1000px;
      margin: 0 auto;
      list-style: none;
      padding: 0;
      /* display: grid; */
      /* grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); */
      gap: 40px;
    }
    
    .benefits-list li {
      margin-bottom: 20px;
      background: white;
      padding: 40px 30px;
      border-radius: 20px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.08);
      font-size: 16px;
      color: #555;
      text-align: left;
      position: relative;
      padding-left: 80px;
      transition: all 0.3s ease;
      border: 1px solid rgba(102, 126, 234, 0.1);
      list-style: none;
    }
    
    .benefits-list li:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0,0,0,0.12);
      border-color: rgba(102, 126, 234, 0.2);
    }
    
    .benefits-list li::before {
      content: '';
      position: absolute;
      top: 30px;
      left: 15px;
      width: 50px;
      height: 50px;
      border-radius: 15px;
      background: linear-gradient(135deg, #667eea, #764ba2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      font-weight: bold;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .benefits-list li:nth-child(1)::before {
      content: '∞';
      background: linear-gradient(135deg, #667eea, #764ba2);
    }
    
    .benefits-list li:nth-child(2)::before {
      content: '👤';
      background: linear-gradient(135deg, #f093fb, #f5576c);
    }
    
    .benefits-list li:nth-child(3)::before {
      content: '⚡';
      background: linear-gradient(135deg, #4facfe, #00f2fe);
    }
    
    .benefits-list li h3 {
      margin: 0 0 15px 0;
      font-size: 1.3rem;
      font-weight: 700;
      color: #2c3e50;
    }
    
    .benefits-list li p {
      margin: 0;
      line-height: 1.6;
      color: #666;
    }
    
    /* App Recommendation Section */
    
    /* Choice Section - 白色背景 */
    .choice-section {
      padding: 30px 20px;
      background: white;
    }
    
    .choice-card {
      max-width: 800px;
      margin: 0 auto 30px;
      background: #f8f9fa;
      padding: 30px;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    .choice-card h3 {
      font-size: 1.4rem;
      margin-bottom: 20px;
      color: #333;
      font-weight: 600;
    }
    
    .choice-card ul {
      list-style: none;
      padding: 0;
    }
    
    .choice-card li {
      padding: 12px 0;
      color: #666;
      font-size: 18px;
      border-bottom: 1px solid #e9ecef;
    }
    
    .choice-card li:last-child {
      border-bottom: none;
    }
    
    .choice-image {
      /* text-align: center; */
      width: 230px;
      height: 230px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .choice-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    
    /* FAQ Section - 现代化折叠设计 */
    .faq-section {
      padding: 20px 20px;
      background: white;
      margin-bottom: 20px;
    }
    
    .faq-container {
      max-width: 800px;
      margin: 0 auto;
    }
    
    .faq-item {
      background: white;
      margin-bottom: 20px;
      border-radius: 15px;
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
      overflow: hidden;
      transition: box-shadow 0.3s ease;
    }
    
    .faq-item:hover {
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    }
    
    .faq-question {
      padding: 25px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: background-color 0.3s ease;
    }
    
    .faq-question:hover {
      background: #f8f9fa;
    }
    
    .faq-question h3 {
      margin: 0;
      font-size: 1.2rem;
      color: #2c3e50;
      font-weight: 600;
    }
    
    .faq-toggle {
      font-size: 1.5rem;
      font-weight: bold;
      color: #667eea;
      transition: transform 0.3s ease;
    }
    
    .faq-item.expanded .faq-toggle {
      transform: rotate(45deg);
    }
    
    .faq-answer {
      padding: 0 25px 25px;
      color: #555;
      line-height: 1.6;
        font-size: 16px;
      }
      
    /* Responsive Design */
    @media (max-width: 768px) {
      .hero-section {
        padding: 40px 20px 60px;
      }
      
      .logo-sss {
        font-size: 2rem;
      }
      
      .logo-instagram {
        font-size: 1.5rem;
      }
      
      .nav-tabs {
        gap: 6px;
        margin-bottom: 40px;
        padding: 6px;
        border-radius: 25px;
      }
      
      .nav-tab {
        padding: 8px 12px;
        font-size: 11px;
      }
      
      .hero-title {
        font-size: 2rem;
        margin-bottom: 40px;
      }
      
      .input-group {
        flex-direction: column;
        gap: 8px;
        border-radius: 12px;
        padding: 12px;
      }
      
      .link-input, .paste-btn, .download-btn {
        border-radius: 8px;
        width: 100%;
      }
      
      .paste-btn {
        margin-right: 0;
        margin-bottom: 8px;
      }
      
      .section-title {
        font-size: 1.8rem;
      }
      
      
      .app-content {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .app-image {
        width: 200px;
        height: 200px;
      }
      
      
      .feature-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-card {
        padding: 25px;
      }
      
      .benefits-list {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .benefits-list li {
        padding: 30px 25px;
        padding-left: 70px;
      }
      
      .benefits-list li::before {
        width: 45px;
        height: 45px;
        top: 25px;
        left: 20px;
        font-size: 20px;
      }
      
      .faq-question {
        padding: 20px;
      }
      
      .faq-answer {
        padding: 0 20px 20px;
    }
    }
    </style>
    